import(/* webpackMode: "eager" */ "D:\\medallion-homes\\src\\app\\careers\\page.tsx");
